import { useRequest } from "~/v2/api/hooks";
import {
  getAtdOrderFills,
  ORDER_FILLS_REQUEST_PAGE_SIZE,
  orderFillsQueryKeys,
} from "~/v3-poc/api/orderFills";
import type { OrderFill } from "~/v3-poc/api/orderFills.schema";

export interface UseAtdOrderFillsParams {
  accountID?: string;
  product?: "live" | "paper";
  orderID?: string;
  pageToken?: string;
  enabled: boolean;
}

export const useAtdOrderFills = ({
  accountID,
  product,
  orderID,
  pageToken,
  enabled,
}: UseAtdOrderFillsParams) =>
  useRequest<OrderFill[]>(
    orderFillsQueryKeys.page({
      accountID: accountID ?? "",
      product,
      orderID: orderID ?? "",
      pageToken,
    }),
    () => {
      if (!accountID || !product || !orderID) {
        return Promise.resolve([]);
      }
      return getAtdOrderFills({
        accountID,
        product,
        orderID,
        pageSize: ORDER_FILLS_REQUEST_PAGE_SIZE,
        pageToken,
      });
    },
    {
      enabled: enabled && Boolean(accountID && product && orderID),
      meta: { showErrorToast: false },
      retry: false,
    },
  );
